var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"fd-news-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"fd-news-message"},[_c('p',[_vm._v("发布时间："+_vm._s(_vm.date))]),_vm._v(" "),_c('p',[_vm._v("发布法院："+_vm._s(_vm.fy))])])])}
var staticRenderFns = []

export { render, staticRenderFns }